import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { CAPITAL, CONTACT_US_TRIGER, CUSTOM_SELECT_STYLES, SELECT_BOX_THEME } from '../../constants';
import ContactUs from '../../components/ContactUs/ContactUs';
import CurrencyFormat from '../../components/currencyFormat/currencyFormat';
import { Controller, useForm } from 'react-hook-form';
import Select from "react-select";
import { addCapital } from '../../actions/capital';
import Header from '../../components/header/header';
import { useNavigate } from 'react-router';
import { RoutesPaths } from '../../Router/constant';

export default function CapitalAddEdit() {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { shareCapital } = useSelector((state) => state.capital);
    const { selectedCompany } = useSelector((state) => state.company);
    const [contactLoader, setContactLoader] = useState(false);
    const {
        register,
        control,
        handleSubmit,
        reset,
        getValues,
        formState: { errors },
    } = useForm();

    const onSubmit = async (data) => {
        setContactLoader(true);
        if (selectedCompany?.id) {
            data.company = selectedCompany?.id;
            data.capitalType = CAPITAL.shared;
            data.shareType = parseInt(data?.shareType?.value);
            data.currency = data?.currency?.value;

            const paidUpCapitalPayload = {
                shareCapital: data.shareCapital,
                currency: data.currency,
                shareType: data.shareType,
                company: data.company,
                capitalType: CAPITAL.paidUp
            }

            await dispatch(addCapital(data));
            await dispatch(addCapital(paidUpCapitalPayload));
            reset();
            navigate(RoutesPaths.PAIDUPCAPITALPAY)
        }
        setContactLoader(false);
    };
    return (
        <div>
            <Header />
            <div className="container-fluid">
                <div className="shareCard">
                    <div className="row">
                        <div className="col-12">
                            <h5 className="suggestHeader">
                                {shareCapital?.length === 0 ? "Add" : "Edit"}{" "}
                                share capital
                            </h5>
                            <div>
                                <p className="edit-description-content">
                                    Every business needs a minimum of 1 share and 1 dollar (SGD or USD), as a share capital. Some businesses require a
                                    larger share capital for reasons such as tendering for a
                                    contract or attracting stakeholders.
                                </p>
                                <p className="edit-description-content">
                                    You can add shares, share capital, in SGD or USD
                                    and determine the share type as many times as you need to.
                                    You cannot subtract shares and share capital.
                                </p>
                                <p className="edit-description-content">
                                    We will be sending you notifications to confirm the share
                                    capital additions.
                                </p>
                            </div>
                        </div>
                        <div className="col-12 marginTopCol">
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-6 col-md-3">
                                        <div className="form-group">
                                            <p className="accountPrimaryText">
                                                Current share capital
                                            </p>
                                            <div className='shareDetail'>
                                                <span className="accountSecondaryText">
                                                    {shareCapital?.length > 0 && "$ "}{" "}
                                                    {shareCapital?.length === 0 ? (
                                                        "-"
                                                    ) : (
                                                        <CurrencyFormat value={shareCapital[shareCapital?.length - 1].shareCapital} />
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-9">
                                        <div className="form-group">
                                            <div>
                                                <p className="accountPrimaryText">
                                                    Add share capital
                                                </p>
                                                <input
                                                    autoComplete="off"
                                                    type="text"
                                                    className="form-control marginTopInput"
                                                    placeholder="Amount to add"
                                                    maxLength={20}
                                                    {...register("shareCapital", {
                                                        required: true,
                                                        min: {
                                                            value: 100, // Minimum value
                                                            message: 'Minimum value must be at least 100'
                                                        }
                                                    })}
                                                    onKeyPress={(event) => {
                                                        // Allow only numbers, Backspace, and Delete keys
                                                        const allowedChars = /[0-9\b\.]/;
                                                        if (!allowedChars.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {errors.shareCapital?.type === "min" && (
                                                    <span className="errorMessage">{errors?.shareCapital?.message}</span>
                                                )}
                                                {errors.shareCapital?.type === "required" && (
                                                    <span className="errorMessage">
                                                        Add Share capital is required
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-6 col-md-3">
                                        <div className="form-group">
                                            <p className="accountPrimaryText">Number of shares</p>
                                            <div className='shareDetail'>
                                                <span className="accountSecondaryText">
                                                    {shareCapital?.length === 0
                                                        ? "-"
                                                        : shareCapital[shareCapital?.length - 1].shares}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-9">
                                        <div className="form-group">
                                            <div>
                                                <p
                                                    htmlFor="recipient-name"
                                                    className="accountPrimaryText"
                                                >
                                                    Add number of shares
                                                </p>
                                                <input
                                                    autoComplete="off"
                                                    type="text"
                                                    className="form-control marginTopInput"
                                                    placeholder="Number of shares to be added"
                                                    maxLength={20}
                                                    {...register("shares", {
                                                        required: true,
                                                    })}
                                                    onKeyPress={(event) => {
                                                        // Allow only numbers, Backspace, and Delete keys
                                                        const allowedChars = /[0-9\b\.]/;
                                                        if (!allowedChars.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                />
                                                {errors.shares?.type === "required" && (
                                                    <span className="errorMessage">
                                                        Number of shares to be added
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-6 col-md-3">
                                        <div className="form-group">
                                            <p className="accountPrimaryText">Currency</p>
                                            <div className='shareDetail'>
                                                <span className="accountSecondaryText">
                                                    {shareCapital?.length === 0
                                                        ? "-"
                                                        : shareCapital[shareCapital?.length - 1].currency}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-9">
                                        <div className="form-group">
                                            <div>
                                                <p className="accountPrimaryText">
                                                    Share capital currency
                                                </p>
                                                <Controller
                                                    name="currency"
                                                    rules={{ required: true }}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Select
                                                            className="select-border newFormSelect marginTopInput"
                                                            placeholder="Choose currency"
                                                            {...field}
                                                            options={[
                                                                {
                                                                    value: 'USD',
                                                                    label: "USD"
                                                                }, {
                                                                    value: "SGD",
                                                                    label: "SGD"
                                                                }
                                                            ]}
                                                            getOptionValue={(option) => `${option.value}`}
                                                            theme={SELECT_BOX_THEME}
                                                            styles={CUSTOM_SELECT_STYLES}
                                                        >
                                                        </Select>
                                                    )}
                                                />

                                                {errors.currency?.type === "required" && (
                                                    <span className="errorMessage">
                                                        Select your currency
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-6 col-md-3">
                                        <div className="form-group">
                                            <p className="accountPrimaryText">Share type</p>
                                            <div className='shareDetail'>
                                                <span className="accountSecondaryText">
                                                    {shareCapital?.length === 0
                                                        ? "-"
                                                        : shareCapital[shareCapital?.length - 1]
                                                            .shareType === 1
                                                            ? "Ordinary"
                                                            : "Preference"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-6 col-md-9">
                                        <div className="form-group">
                                            <div>
                                                <p className="accountPrimaryText">Choose share type</p>

                                                <Controller
                                                    name="shareType"
                                                    rules={{ required: true }}
                                                    control={control}
                                                    render={({ field }) => (
                                                        <Select
                                                            className="select-border newFormSelect marginTopInput"
                                                            placeholder="Choose share type"
                                                            {...field}
                                                            options={[
                                                                {
                                                                    value: 1,
                                                                    label: "Ordinary"
                                                                }, {
                                                                    value: 2,
                                                                    label: "Preference"
                                                                }
                                                            ]}
                                                            getOptionValue={(option) => `${option.value}`}
                                                            theme={SELECT_BOX_THEME}
                                                            styles={CUSTOM_SELECT_STYLES}
                                                        >
                                                        </Select>
                                                    )}
                                                />
                                                {errors.shareType?.type === "required" && (
                                                    <span className="errorMessage">
                                                        Select your share type
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="import-note">
                                    Important note: &nbsp;
                                    <span className="will-need-text">
                                        By proceeding, we will notify you directly and advise you
                                        accordingly on the next steps to formalise the changes.
                                    </span>
                                </p>
                                <div className="modal-footer modal-bottom-action">
                                    <ContactUs type={CONTACT_US_TRIGER.SHARE_CAPITAL} />
                                    <button type="submit" className="btn agree-button" disabled={contactLoader}>
                                        {contactLoader && (<i className="animateSpin fa-solid fa-circle-notch"></i>)}&nbsp;Proceed
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
